import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/brand/logo.png`;

// Official Beyond Potentials circular badge logo (transparent PNG).
export const Logo = ({ className, compact = false, onClick }) => {
  return (
    <Link
      to="/"
      onClick={onClick}
      aria-label="Beyond Potentials — home"
      data-testid="brand-logo"
      className={cn("inline-flex items-center", className)}
    >
      <img
        src={LOGO_SRC}
        alt="Beyond Potentials"
        draggable={false}
        className={cn("w-auto select-none", compact ? "h-10" : "h-12")}
      />
    </Link>
  );
};
